<template>
	<div>
		<div class="contentBigBox reviewBox">
			<!--<div class="closeSplitScreen el-icon-circle-close" @click="closeSplitScreen"></div>-->
			<div>
				<div class="presentationTitle">{{ taskInfo.Id }}任务详情</div>
			</div>
			<div class="SpeedOfProgress">
				<steps :active="statusBar"></steps>
				<!-- <el-steps :active="statusBarActive" class="SpeedOfProgressStep">
					<el-step v-for="item in statusBar" :title="item.Text" :description="item.Date" :icon="item.icon"></el-step>
				</el-steps> -->
				<div class="task-condition">
					<el-row>
						<el-col :span="8">
							<div class="grid-content">
								<span>任务名称</span>
								: <span v-if="!editFlag">{{ taskInfo.Name }}</span>
								<el-input v-else v-model="taskInfo.Name" class="name editFroms" @blur="editTaskBlur"
									placeholder="任务名称" size="mini"></el-input>
								<i v-if="taskInfo.CanEditName" class="el-icon-edit dodgerBlue cur" @click="editTaskName"></i>
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>抽样类型</span>
								: {{ taskInfo.CategoryName }}
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>设备类型</span>
								:
								<span v-for="(item, index) in taskInfo.ModalityTypes" :key="index">
									{{ item }}
									<span v-if="index != taskInfo.ModalityTypes.length - 1">/</span>
								</span>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<div class="grid-content">
								<span>抽样主体</span>
								: {{ taskInfo.SubjectType | changeSubjectType }}
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>扫描类型</span>
								: {{ taskInfo.ScanType | formatBodyPart }}
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>检查部位</span>
								:{{ taskInfo.BodyPart | formatBodyPart }}
							</div>
						</el-col>
						<!-- <el-col :span="8">
							<div class="grid-content">
								<span>
									病例样本
									<span>:</span>
								</span>
								{{ taskInfo.IsPositive | formatIsPositive }}
							</div>
						</el-col> -->
					</el-row>
					<el-row>
						<el-col :span="8">
							<div class="grid-content">
								<span>抽样时间</span>
								: {{ taskInfo.StartDate }} ~ {{ taskInfo.EndDate }}
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>评分方案</span>
								: {{ taskInfo.QCPlanName }}
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>评审人数</span>
								: {{ taskInfo.QCTimes }}人/份
							</div>
						</el-col>
					</el-row>
				</div>
				<i class="taskSilder"></i>
				<div class="task-dt">
					<el-row>
						<el-col :span="8">
							<div class="grid-content">
								<span>
									创建人
									<span>:</span>
								</span>
								{{ taskInfo.CreateorName }}
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>创建日期</span>
								: {{ taskInfo.CreateDt }}
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>预估完成日期</span>
								: {{ taskInfo.PlannedCompleteDt | formatBodyPart }}
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<div class="grid-content">
								<span>分配方法</span>:{{
									taskInfo.DistributionMethod == '' || taskInfo.DistributionMethod == '未知' || taskInfo.DistributionMethod == null
										? '未分配'
										: taskInfo.DistributionMethod}}
							</div>
						</el-col>
						<el-col :span="8" v-if="taskInfo.DistributionMethod != '平均分配'">
							<div class="grid-content">
								<span>分配类型</span>: {{ taskInfo.DistributionType }}
								<!-- {{taskInfo.DistributionType==''||taskInfo.DistributionType=='未知'||taskInfo.DistributionType==null?'未分配':taskInfo.DistributionType}} -->
							</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">
								<span>通知专家查看任务</span>:
								<el-button type="primary" size="mini" v-if="taskInfo.CanSendSMS" @click="notice">通知
								</el-button>
								<span v-else>{{ taskInfo.SendSMSDesc }}</span>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24" align="right">
							<span class="allReportList cur"
								@click="distributionClick('all')">查看全部{{ taskInfo.ReportNum }}份报告>></span>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>

		<el-collapse v-model="activeNames" @change="handleChange">
			<div class="contentBigBox reviewBox mt10">
				<el-collapse-item title="抽样结果-医院" name="1">
					<template slot="title">
						抽样结果
					</template>
					<el-table class="qcTable distributionList taskSecondary" :data="resultList">
						<el-table-column width="140" prop="HospitalName" label="中心名称"></el-table-column>
						<el-table-column width="110" prop="" label="审核医生数量" v-if="taskInfo.SubjectType == 2">
							<template slot-scope="scope">
								<span v-if="taskInfo.ModalityTypes[0] == 'US'">{{ scope.row.SubmitterCount }}</span>
								<span v-else>{{ scope.row.FirstApproverCount }}</span>
							</template>
						</el-table-column>
						<el-table-column width="110" prop="" label="诊断医生数量" v-if="taskInfo.SubjectType == 4">
							<template slot-scope="scope">
								<span>{{ scope.row.SubmitterCount }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="TechnicianCount" label="技师数量"></el-table-column>
						<el-table-column width="150" label="抽样方式(每位医生)">
							<template slot-scope="scope">
								<span>{{ scope.row.TypeName }}</span>
								<span>{{ scope.row.TypeValue }}</span>
								<span v-if="scope.row.TypeName == '按比例'">%</span>
								<span v-else>例</span>
							</template>
						</el-table-column>
						<el-table-column prop="Total" label="报告总数"></el-table-column>
						<el-table-column prop="SampledNum" label="抽样数量"></el-table-column>
						<el-table-column prop="Progress" label="完成进度">
							<template slot-scope="scope">
								<el-tooltip effect="dark" placement="top-start">
									<div class="progress">
										<div class="progress-bar progress-bar-success"
											:style="`width: ${Math.floor((scope.row.Progress.split('/')[0] / scope.row.Progress.split('/')[1]) * 100)}%`">
										</div>
										<span
											class="sr-only">{{ Math.floor((scope.row.Progress.split('/')[0] / scope.row.Progress.split('/')[1]) * 100) }}%</span>
									</div>
									<div slot="content" class="tableTooltip">
										<div>
											<em></em>
											<span>已完成数量:{{ scope.row.Progress.split('/')[0] }}</span>
										</div>
									</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="ReportAverageScore" width="100" label="报告平均分"></el-table-column>
						<el-table-column prop="ImageAverageScore" width="100" label="影像平均分"></el-table-column>
						<el-table-column prop="samplingMethod" width="150" label="报告占比(阴性:阳性)">
							<template slot-scope="scope">
								<div class="center">
									{{scope.row.Negative}} : {{scope.row.Positive}}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="NegativeCount" label="阴性"></el-table-column>
						<el-table-column prop="PositiveCount" label="阳性"></el-table-column>
						<el-table-column prop="HasSend2CD" label="通知">
							<template slot-scope="scope">
								<span v-if="scope.row.HasSend2CD">已通知</span>
								<span v-else>未通知</span>
							</template>
						</el-table-column>
						<el-table-column prop="" label="操作" width="260" fixed="right">
							<template slot-scope="scope">
								<span class="tableOpe marr15"
									@click="distributionClick('hospital', scope.row)">查看报告</span>
								<el-dropdown class="marr15">
									<span class="el-dropdown-link">
										查看结果
										<i class="el-icon-arrow-down"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="a"><span
												@click="resultClick('技师', scope.row)">技师结果</span></el-dropdown-item>
										<el-dropdown-item command="b" v-if="taskInfo.SubjectType == 2"><span
												@click="resultClick('审核医生', scope.row)">审核医生结果</span></el-dropdown-item>
										<el-dropdown-item command="c" v-if="taskInfo.SubjectType == 4"><span
												@click="resultClick('诊断医生', scope.row)">诊断医生结果</span></el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<el-dropdown class="marr15">
									<span class="el-dropdown-link">
										更多
										<i class="el-icon-arrow-down"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="d" v-if="taskInfo.Status == 50&&scope.row.CanSend2CD"><span
												@click="noticeDoctorClick(scope.row)">通知医生</span></el-dropdown-item>
										<el-dropdown-item command="a"><span
												@click="exportSetClick(scope.row)">导出设置</span></el-dropdown-item>
										<el-dropdown-item command="b"
											v-if="Math.floor((scope.row.Progress.split('/')[0] / scope.row.Progress.split('/')[1]) * 100) == 100">
											<span @click="exportClick(scope.row)">导出word</span>
										</el-dropdown-item>
										<el-dropdown-item command="c"><span
												@click="unSelectedDoctorsClick(scope.row)">未抽样医生</span>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<!-- <span class="tableOpe" v-if="statusBar[statusBar.length-1].Date" @click="exportClick(scope.row)">导出</span> -->
							</template>
						</el-table-column>
					</el-table>
					<el-dialog title="导出设置" :visible.sync="dialogVisible" width="60%"
						class="scrollbar exportFrom dialogFrom">
						<el-form class="qcFrom" ref="setExportFrom" distinguishCancelAndClose :rules="rules"
							:model="exportFrom">
							<el-row>
								<el-form-item prop="PurposeTxt">
									<span slot="label">
										一、质控的目的与意义
										<br />
									</span>
									<el-input type="textarea" class="exportTextInput" size="small"
										v-model="exportFrom.PurposeTxt" placeholder="请输入质控的目的与意义"></el-input>
								</el-form-item>
								<el-form-item prop="SamplingTypeTxt">
									<span slot="label">
										二、质控抽样及评分规则
										<br />
									</span>
									<el-input type="textarea" class="exportTextInput" size="small"
										v-model="exportFrom.SamplingTypeTxt" placeholder="请输入质控抽样及评分规则"></el-input>
								</el-form-item>
								<el-form-item prop="QCTypeTxt">
									<span slot="label">
										三、质控方式
										<br />
									</span>
									<el-input type="textarea" class="exportTextInput" size="small"
										v-model="exportFrom.QCTypeTxt" placeholder="请输入质控方式"></el-input>
								</el-form-item>
								<el-form-item prop="SuggestTxt">
									<span slot="label">
										四、建议
										<br />
									</span>
									<el-input type="textarea" class="exportTextInput" size="small"
										v-model="exportFrom.SuggestTxt" placeholder="请输入建议"></el-input>
								</el-form-item>
								<div class="el-form-item__error">* 如需换行请用"/n"隔开</div>
							</el-row>
						</el-form>
						<div class="dialog-footer mart25" align="center">
							<el-button type="primary" size="small" @click="preservation(1)">保 存</el-button>
							<el-button type="primary" size="small"
								v-if="setExportList.Progress && Math.floor((setExportList.Progress.split('/')[0] / setExportList.Progress.split('/')[1]) * 100) == 100"
								@click="preservation(2)">
								保存并导出
							</el-button>
						</div>
					</el-dialog>
					<div class="collapseBox" v-if="collapseflag.flag">
						<div class="collapseBox-title">
							{{ collapseName.hospital }}{{ collapseName.name }} (
							<span v-if="collapseName.name == '未抽样医生'">{{ unSelectedDoctorsList.length }}</span>
							<span v-else>{{ doctorsResultList.length }}</span>
							人)
							<i class="el-icon-close" @click="closeRbox"></i>
						</div>
						<el-table v-if="collapseName.name == '未抽样医生'" class="qcTable distributionList"
							key="collapseName.name" :data="unSelectedDoctorsList">
							<el-table-column prop="DoctorName" label="医生姓名"></el-table-column>
							<el-table-column prop="Note" label="备注"></el-table-column>
						</el-table>
						<el-table v-else class="qcTable distributionList" :data="doctorsResultList">
							<el-table-column prop="DoctorName" label="诊断医生" v-if="collapseName.name == '诊断医生'">
							</el-table-column>
							<el-table-column prop="DoctorName" label="审核医生" v-else-if="collapseName.name == '审核医生'">
							</el-table-column>
							<el-table-column prop="DoctorName" label="抽样技师" v-else></el-table-column>
							<el-table-column prop="Total"
								v-if="collapseName.name == '诊断医生'||collapseName.name == '审核医生'" label="报告总数">
							</el-table-column>

							<el-table-column prop="SampledNum" label="抽样数量"></el-table-column>
							<el-table-column prop="Progress" label="完成进度">
								<template slot-scope="scope">
									<el-tooltip effect="dark" placement="top-start">
										<div class="progress">
											<div class="progress-bar progress-bar-success"
												:style="`width: ${Math.floor((scope.row.Progress.split('/')[0] / scope.row.Progress.split('/')[1]) * 100)}%`">
											</div>
											<span
												class="sr-only">{{ Math.floor((scope.row.Progress.split('/')[0] / scope.row.Progress.split('/')[1]) * 100) }}%</span>
										</div>
										<div slot="content" class="tableTooltip">
											<div>
												<em></em>
												<span>已完成数量:{{ scope.row.Progress.split('/')[0] }}</span>
											</div>
										</div>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column prop="ReportAverageScore" label="报告平均分"
								v-if="collapseName.name == '审核医生'||collapseName.name == '诊断医生'"></el-table-column>
							<el-table-column prop="ImageAverageScore" label="影像平均分" v-else></el-table-column>
							<el-table-column prop="" label="操作" width="240">
								<template slot-scope="scope">
									<span class="tableOpe" @click="distributionClick('doctor', scope.row)">查看报告</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-collapse-item>
			</div>
			<div class="contentBigBox reviewBox mt10">
				<el-collapse-item title="专家进度详情" name="2">
					<template slot="title">
						专家进度
					</template>
					<el-table class="qcTable distributionList" :data="distributionInfo">
						<!-- <el-table-column prop="HospitalName" label="中心名称" v-if="taskInfo.DistributionMethod=='非平均按医院'"></el-table-column> -->
						<el-table-column prop="ExpertName" label="专家姓名"></el-table-column>
						<el-table-column prop="TotalNum" label="总数"></el-table-column>
						<el-table-column prop="CompletedNum" label="完成数量"></el-table-column>
						<el-table-column prop="ImgAvgScore" label="影像平均分"></el-table-column>
						<el-table-column prop="ReportAvgScore" label="报告平均分"></el-table-column>
						<el-table-column prop="SubjectiveHistoryAvgScore" label="病史平均分"></el-table-column>
						<el-table-column prop="Progress" label="完成进度">
							<template slot-scope="scope">
								<el-tooltip effect="dark" placement="top-start">
									<div class="progress">
										<div class="progress-bar progress-bar-success"
											:style="`width: ${Math.floor((scope.row.CompletedNum / scope.row.TotalNum) * 100)}%`">
										</div>
										<span
											class="sr-only">{{ Math.floor((scope.row.CompletedNum / scope.row.TotalNum) * 100) }}%</span>
									</div>
									<div slot="content" class="tableTooltip">
										<div>
											<em></em>
											<span>已完成数量:{{ scope.row.CompletedNum }}</span>
										</div>
									</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="CompleteDateTime" :formatter="formattertime" min-width="100"
							label="完成时间"></el-table-column>
						<el-table-column prop="" label="操作" fixed="right" width="300">
							<template slot-scope="scope">
								<span class="tableOpe"
									@click="distributionClick('expert', scope.row)">查看报告</span>
								<span class="tableOpe marl15" v-if="taskInfo.DistributionMethod == '非平均按医院'"
									@click="expertClick(scope.row)">查看详情</span>
								<span
									class="tableOpe marl15"
									:class="{ disabled: scope.row.TotalNum === scope.row.CompletedNum }"
									@click="handleRedistribute(scope.row)"
								>
									重新分发
								</span>
								<span
									class="tableOpe marl15"
									:class="{ disabled: !scope.row.IsDistribute }"
									@click="handleDistributeDetails(scope.row)"
								>
									分发详情
								</span>
							</template>
						</el-table-column>
					</el-table>
					<div class="collapseBox" v-if="expertflag.flag">
						<div class="collapseBox-title">
							{{ expertName.name }}详情 (
							<span v-if="expertHospitalList">{{ expertHospitalList.length }}</span>
							家)
							<i class="el-icon-close" @click="closeExpertbox"></i>
						</div>
						<el-table class="qcTable distributionList" :data="expertHospitalList">
							<el-table-column prop="HospitalName" label="中心名称"></el-table-column>
							<el-table-column prop="TotalNum" label="总数"></el-table-column>
							<el-table-column prop="CompletedNum" label="完成数量"></el-table-column>
							<el-table-column prop="ImgAvgScore" label="影像平均分"></el-table-column>
							<el-table-column prop="ReportAvgScore" label="报告平均分"></el-table-column>
							<el-table-column prop="CompleteDateTime" :formatter="formattertime" min-width="100" label="完成时间"></el-table-column>
							<el-table-column prop="" label="操作" width="240">
								<template slot-scope="scope">
									<span class="tableOpe" @click="distributionClick('hospital', scope.row)">查看报告</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-collapse-item>
			</div>
		</el-collapse>
	</div>
</template>

<script>
	import Api from '../../api';
	import axios from '@/js/api';
	import steps from '../tool/steps.vue';
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				activeNames: ['1', '2'],
				active: 0,
				currentRow: null,
				height: 0,
				datas: {},
				collapseName: {
					name: '',
					hospital: ''
				},
				expertName: {
					name: ''
				},
				unSelectedDoctorsList: [],
				expertHospitalList: [],
				dialogVisible: false,
				exportFrom: {
					SamplingTaskGuid: '',
					HospitalGuid: '',
					PurposeTxt: '',
					SamplingTypeTxt: '',
					QCTypeTxt: '',
					SuggestTxt: ''
				},
				rules: {
					PurposeTxt: [{
						required: true,
						message: '请输入质控的目的与意义',
						trigger: 'blur'
					}],
					SamplingTypeTxt: [{
						required: true,
						message: '请输入质控抽样及评分规则',
						trigger: 'blur'
					}],
					QCTypeTxt: [{
						required: true,
						message: '请输入质控方式',
						trigger: 'blur'
					}],
					SuggestTxt: [{
						required: true,
						message: '请输入建议',
						trigger: 'blur'
					}]
				},
				setExportList: {
					Progress: '0/0'
				},
				editFlag: false
			};
		},
		components: {
			steps
		},
		computed: {
			...Vuex.mapState('managerPlanList', [
				'doctorsResultList',
				'resultList',
				'reviewName',
				'loading',
				'pageIndex',
				'getExpertReportListParameter',
				'taskInfo',
				'statusBar',
				'distributionInfo',
				'SamplingTaskGuId'
			]),
			...Vuex.mapState('doctor', ['taskListTitle']),
			...Vuex.mapState('breadcrumb', ['collapseflag', 'selectRow', 'expertflag']),
			statusBarActive() {
				this.statusBar.forEach((item, index) => {
					if (item.Date != null) {
						this.active = index;
					}
				});
				return this.active + 1;
			}
		},
		filters: {
			formatIsPositive: function(value) {
				return {
					'': '不限',
					'1': '阳性',
					'2': '阴性',
					'0': '未知'
				} [value] || value;
			},
			formatBodyPart: function(value) {
				return {
					'': '不限',
					null: '不限',
					undefined: '不限'
				} [value] || value;
			},
			changeSubjectType: function(value) {
				return ({
					'': '不限',
					'3': '影像技师',
					'4': '诊断医生',
					'2': '审核医生',
				} [value] || '不限');
			},

		},
		created() {
			this.collapseflag.flag = false;
			this.expertflag.flag = false;
		},
		activated() {
			this.setLoading(true);
			//清空入参
			this.clearSecondListParameter();
			this.setSecondListParameter({
				SamplingTaskGuid: this.SamplingTaskGuId.SamplingTaskGuid
			});
			this.setTaskStatus(0);
			this.GetTaskDetail();
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType']),
			...Vuex.mapMutations('managerPlanList', [
				'clearSecondListParameter',
				'setTaskStatus',
				'setSecondListParameter',
				'setLoading',
				'setTaskSecond',
				'currentChangesSecond',
				'clearparameter'
			]),
			...Vuex.mapActions('managerPlanList', ['GetDoctorsResult', 'GetTaskDetail', 'GetExpertReportList',
				'SendSMS2Expert','SendHospitalOk2CD'
			]),
			noticeDoctorClick(row){
				this.SendHospitalOk2CD({
				  "SamplingTaskGuid": this.SamplingTaskGuId.SamplingTaskGuid,
				  "HospitalGuid": row.HospitalGuid,
				  "Type": 0,
				  "DoctorName": ''
				})
			},
			//任务名称修改
			editTaskName() {
				this.editFlag = true;
				this.editOldName = JSON.parse(JSON.stringify(this.taskInfo.Name));
			},
			editTaskBlur() {
				axios.ajaxPost('post', Api.api.manager.UpdateTaskName, {
					"SamplingTaskGuid": this.SamplingTaskGuId.SamplingTaskGuid,
					"OldName": this.editOldName,
					"NewName": this.taskInfo.Name
				}).then(res => {
					if(res.StatusCode == 200){
						this.editFlag = false;
						this.$message({
							message: '修改成功',
							type: 'success'
						});
					}
				})
			},
			//通知专家查看任务
			notice() {
				this.$confirm('确定给专家发送查看任务的消息吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					})
					.then(() => {
						this.SendSMS2Expert({
							samplingTaskGuid: this.SamplingTaskGuId.SamplingTaskGuid
						}).then(res => {
							this.$message({
								message: '发送成功',
								type: 'success'
							});
							this.taskInfo.CanSendSMS = false;
							this.taskInfo.SendSMSDesc = '分配已提醒';
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消发送'
						});
					});
			},
			//导出
			exportClick(row) {
				window.open(axios.exportExcel(Api.api.manager.ExportQCReport) + '?samplingTaskGuid=' + this
					.SamplingTaskGuId.SamplingTaskGuid + '&hospitalGuid=' + row.HospitalGuid);
			},
			//导出设置
			exportSetClick(row) {
				this.dialogVisible = true;
				this.setExportList = row;
				axios
					.ajaxGet('get', Api.api.manager.GetExportContent, {
						samplingTaskGuid: this.SamplingTaskGuId.SamplingTaskGuid,
						hospitalGuid: row.HospitalGuid
					})
					.then(res => {
						this.exportFrom = res.data.ExportWordSettings;
					});
			},
			//保存与导出
			preservation(type) {
				let _this = this;
				this.exportFrom.SamplingTaskGuid = this.SamplingTaskGuId.SamplingTaskGuid;
				this.exportFrom.HospitalGuid = this.setExportList.HospitalGuid;
				this.$refs.setExportFrom.validate(valid => {
					if (valid) {
						axios.ajaxPost('post', Api.api.manager.SetExportContent, _this.exportFrom).then(res => {
							if (res.data.StatusCode == 200) {
								if (type == 1) {
									_this.$message({
										message: '修改成功',
										type: 'success'
									});
								} else {
									_this.exportClick(_this.setExportList);
								}
								_this.dialogVisible = false;
							}
						});
					} else {
						return false;
					}
				});
			},
			// 未选中医生
			unSelectedDoctorsClick(row) {
				this.collapseName.name = '未抽样医生';
				this.collapseflag.flag = true;
				this.collapseName.hospital = row.HospitalName;
				axios
					.ajaxGet('get', Api.api.manager.GetUnSelectedDoctors, {
						samplingTaskGuid: this.SamplingTaskGuId.SamplingTaskGuid,
						hospitalGuid: row.HospitalGuid
					})
					.then(res => {
						this.unSelectedDoctorsList = res.data.Doctors;
					});
			},
			resultClick(val, row) {
				this.collapseflag.flag = true;
				this.collapseName.name = val;
				this.collapseName.hospital = row.HospitalName;
				this.getExpertReportListParameter.HospitalGuid = row.HospitalGuid;
				this.getExpertReportListParameter.DoctorType = val == '审核医生' ? 2 : val == '诊断医生' ? 4 : 3;
				//2审核医生3技师
				this.GetDoctorsResult({
					SamplingTaskGuid: this.SamplingTaskGuId.SamplingTaskGuid,
					HospitalUid: row.HospitalGuid,
					DoctorType: val == '审核医生' ? 2 : val == '诊断医生' ? 4 : 3
				});
			},
			expertClick(row) {
				this.expertflag.flag = true;
				this.expertName.name = row.ExpertName;
				axios
					.ajaxGet('get', Api.api.manager.GetExpertDistributionDetail, {
						samplingTaskGuid: this.SamplingTaskGuId.SamplingTaskGuid,
						expertUserGuid: row.ExpertUserGuid
					})
					.then(res => {
						this.expertHospitalList = res.data.Distributions;
					});
			},
			closeExpertbox() {
				this.expertflag.flag = false;
			},
			closeRbox() {
				this.collapseflag.flag = false;
			},
			formattertime(row, column, cellValue) {
				if (cellValue != '' && cellValue != null) {
					return cellValue.substring(0, cellValue.length - 3);
				} else {
					return cellValue;
				}
			},
			distributionClick(val, row) {
				this.setLoading(true);
				this.currentChangesSecond(1);
				this.setTootipType(false);
				this.reviewName.exports = false;
				this.getExpertReportListParameter.SamplingTaskGuid = this.SamplingTaskGuId.SamplingTaskGuid;
				//先清空再赋值
				this.clearparameter();
				let name = '';
				switch (val) {
					case 'all':
						name = '';
						break;
					case 'hospital':
						name = row.HospitalName;
						this.getExpertReportListParameter.ExpertUserGuid = row.ExpertUserGuid;
						this.getExpertReportListParameter.HospitalGuid = row.HospitalGuid;
						this.getExpertReportListParameter.DoctorType = 0;
						break;
					case 'doctor':
						name = row.DoctorName;
						this.getExpertReportListParameter.DoctorName = row.DoctorName;
						this.getExpertReportListParameter.HospitalGuid = row.HospitalGuid;
						break;
					case 'expert':
						name = row.ExpertName;
						this.getExpertReportListParameter.ExpertUserGuid = row.ExpertUserGuid;
						this.getExpertReportListParameter.DoctorType = 0;
						break;
				}
				this.reviewName.name = name;
				this.reviewName.SubjectType = this.taskInfo.SubjectType;
				// this.GetExpertReportList();
				this.$router.push('/home/manager/task/reviewReportList');
			},
			handleChange() {},
			// //分页
			// currentChange(val) {
			// 	this.setLoading(true);
			// 	this.selectRow.pageIndex = val;
			// 	this.setTootipType(false);
			// 	this.currentChangesSecond(val)
			// 	this.GetExpertReportList();
			// },
			tabClick(tab, event) {
				this.exportDoctorStatusMu(tab.name);
				this.GetExpertReportList();
			},
			closeSplitScreen() {
				this.setLoading(false);
				this.setTaskSecond(false);
			},
			filterTagTable(filters) {
				this.currentChangesSecond(1);
				this.setTootipType(false);
				let HospitalUid = [],
					DoctorType = [],
					ModalityType = [],
					Status = [],
					keyName = '';
				if (filters.HospitalUid) {
					this.$refs.multipleTable.clearFilter(['ModalityType', 'Status']);
					HospitalUid = filters.HospitalUid.join(',');
				}
				if (filters.DoctorType) {
					DoctorType = filters.DoctorType.join(',');
				}
				if (filters.ModalityType) {
					this.$refs.multipleTable.clearFilter(['HospitalUid', 'Status']);
					ModalityType = filters.ModalityType.join(',');
				}
				if (filters.Status) {
					this.$refs.multipleTable.clearFilter(['HospitalUid', 'ModalityType']);
					Status = filters.Status.join(',');
				}
				if (HospitalUid && HospitalUid != '') {
					keyName = HospitalUid;
				}
				if (ModalityType && ModalityType != '') {
					keyName = ModalityType;
				}
				this.getExpertReportListParameter.KeyName = keyName;
				// this.getExpertReportListParameter.Status = Status;
				this.getExpertReportListParameter.statusList = '';
				this.setLoading(true);
				this.GetExpertReportList();
			},
			array2Str: function(datas) {
				if (datas) {
					let str = '';
					for (let i = 0; i < datas.length; i++) {
						str += '<p>' + datas[i] + '</p>';
					}
					return str;
				}
			},
			// 重新分发
			handleRedistribute(row) {
				if (row.TotalNum === row.CompletedNum) return
				this.$router.push('/home/manager/task/redistribute?expertUserId=' + row.ExpertUserGuid)
			},
			// 分发详情
			handleDistributeDetails(row) {
				if (!row.IsDistribute) return
				this.$router.push('/home/manager/task/distributeDetails?expertUserId=' + row.ExpertUserGuid)
			}
		}
	};
</script>
<style lang="scss" scoped="scoped">
	@import '@/assets/style/variables.scss';
	@import "@/assets/style/mixin.scss";

	.contentBigBox {
		padding-top: 36px;
	}

	.taskSecondary .el-dropdown-link {
		color: #248afd;
	}

	.taskSecondary .el-icon-arrow-down {
		color: #248afd !important;
	}

	.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		color: #248afd !important;
	}

	.exportTextTitle {
		font-size: 14px;
		color: #ffffff;
	}

	.qcFrom>>>.el-textarea__inner {
		@include text-color(fzColor);
		// background: #282b32 !important;
		@include bg-color(dialogarea);
		margin: 14px 0 5px;
		min-height: 75px !important;
	}

	.qcFrom>>>.el-form-item__label {
		font-size: 14px !important;
	}

	.contentBigBox {
		padding: 9px 20px !important;
	}

	.name {
		width: 60%;
		margin-right: 5px;
	}
</style>
